// import React from 'react';
// import "./content.scss"

// import img3 from "../van photos/image_fx_.jpg";
// import img4 from "../van photos/image_fx_ (1).jpg";
// import img5 from "../van photos/image_fx_ (2).jpg";
// import img6 from "../van photos/image_fx_ (3).jpg";
// import img7 from "../van photos/image_fx_ (4).jpg";
// import img8 from "../van photos/image_fx_ (5).jpg";
// import { useNavigate } from 'react-router-dom';
// function Content() {
//   // https://deepai.org/machine-learning-model/text2img
//   const navigate = useNavigate()
//   const navigateToJobs = () => {
//     navigate('/jobs')
//     window.scroll({top:0,behavior:'smooth'})
//   }
//   return (
//     <div className='content'>
//       <div className="baner">
//         <img src={img8} alt="" />
//       </div>
//       <div className="baner_text">
//         <img src={img7} alt="" />
//         <div className='text'>
//           <h1>Nassco Transport GmbH</h1>
//           <h2>Transporter wagen für das ganze Deutschland</h2>
//         </div>
//       </div>

//       <div className="two">
//         <img src={img3} alt="" />
//         <div className='text'>
//           <h1>Günstig und schnell</h1>
//           <p>Wir stehen Ihnen gerne bei der Umzugsplanung zur Verfügung.</p>
//           <p>Wir sind jederzeit für Sie da.</p>
//           <p>Ihre Angelegenheit wird sicher an das Ziel gebracht.</p>
//           <p>Das freundliche Team, das stets mit lächeln und arbeiten vom Hertz.</p>
//           <p>Einfach anrufen und einen schnellen Termin vereinbaren.</p>
//         </div>
//       </div>

//       <div className="one">
//         <img src={img4} alt="" />
//         <div className='text'>
//           <h1>Dienstleistungen</h1>
//           <p>Detaillierte Beschreibung der angebotenen Dienstleistungen (z.B. Privatumzüge, Firmenumzüge, Einlagerungen)</p>
//           <p>Schnelle, sichere und zuverlässige Paketzustellung – Ihr Partner für reibungslose Lieferungen!</p>
//         </div>
//       </div>

//       <div className="two">
//         <img src={img5} alt="" />
//         <div className='text'>
//           <h1>Sicherheit und Versicherung</h1>
//           <p>Informationen zur Versicherung und zu Sicherheitsmaßnahmen während des Umzugs (z.B. Schutz der Möbel, Haftung im Falle von Schäden).</p>
//         </div>
//       </div>

//       <div className="one">
//         <img src={img6} alt="" />
//         <div className='text'>
//           <h1>Werde Teil unseres Teams!</h1>
//           <p>Du bist auf der Suche nach einer neuen Herausforderung und möchtest in einem dynamischen, freundlichen Team arbeiten? Dann bist du bei uns genau richtig! Wir suchen zuverlässige und engagierte Mitarbeiter (m/w)</p>
//           <button onClick={navigateToJobs}>BEWERBEN</button>
//         </div>
//       </div>


//     </div>
//   )
// }

// export default Content
import React from 'react';
import "./content.scss";
import img1 from "../van photos/img1.png";
import img2 from "../van photos/img2.png";
import img3 from "../van photos/img3.png";
import img4 from "../van photos/img4.png";
import img5 from "../van photos/img5.png";
import img6 from "../van photos/img6.png";
import img7 from "../van photos/img7.png";
import img8 from "../van photos/img8.png";
import img9 from "../van photos/img9.png";
import { useNavigate } from 'react-router-dom';

function Content() {
  const navigate = useNavigate();

  const navigateToJobs = () => {
    navigate('/jobs');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="content-modern">
       {/* Hero Section */}
       <section className="hero-section">
          <div className="hero-image-container">
            <img src={img7} alt="Nassco Transport" />
          </div>
          {/* <div className="hero-text">
            <h1>Nassco Transport GmbH</h1>
            <p className="tagline">Zuverlässiger Transportpartner für ganz Deutschland</p>
          </div> */}
        </section>

      {/* Content Grid */}
      <div className="cards-grid">
        <article className="info-card">
          <img src={img1} alt="Schnell und günstig" />
          <div className="card-content">
            <h2>Preiswert und effizient</h2>
            <ul>
              <li>Individuelle Unterstützung bei der Planung Ihres Umzugs</li>
              <li>Stets erreichbar für Fragen und Wünsche</li>
              <li>Zuverlässiger und pünktlicher Transport</li>
              <li>Engagiertes und hilfsbereites Team</li>
              <li>Schnelle Terminabsprache per Telefon</li>
            </ul>
          </div>
        </article>

        <article className="info-card reverse">
          <img src={img3} alt="Dienstleistungen" />
          <div className="card-content">
            <h2>Unser Leistungsangebot</h2>
            <p>Wir decken ein breites Spektrum an Transportservices ab:</p>
            <ul>
              <li>Umzüge für Privatpersonen und Unternehmen</li>
              <li>Transport und Lagerung von Möbeln</li>
              <li>Deutschlandweite Paketlieferungen – schnell und zuverlässig</li>
            </ul>
          </div>
        </article>

        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-image-container">
            <img src={img6} alt="Nassco Transport" />
          </div>
          {/* <div className="hero-text">
            <h1>Nassco Transport GmbH</h1>
            <p className="tagline">Zuverlässiger Transportpartner für ganz Deutschland</p>
          </div> */}
        </section>


        <article className="info-card">
          <img src={img4} alt="Sicherheit" />
          <div className="card-content">
            <h2>Schutz & Absicherung</h2>
            <p>Bei uns sind Ihre Waren in sicheren Händen:</p>
            <ul>
              <li>Umfassender Versicherungsschutz während des Transports</li>
              <li>Sorgfältige Sicherung sensibler und zerbrechlicher Güter</li>
              <li>Geschultes Personal und zeitgemäße Fahrzeugflotte</li>
            </ul>
          </div>
        </article>

         {/* Hero Section */}
         <section className="hero-section">
          <div className="hero-image-container">
            <img src={img8} alt="Nassco Transport" />
          </div>
          {/* <div className="hero-text">
            <h1>Nassco Transport GmbH</h1>
            <p className="tagline">Zuverlässiger Transportpartner für ganz Deutschland</p>
          </div> */}
        </section>

        <article className="info-card">
          <img src={img9} alt="Dienstleistungen" />
          <div className="card-content">
            <h2>Unsere Leistungen im Bereich Paketlogistik</h2>
            <p>Wir bieten zuverlässige Zustellservices im Auftrag von Hermes und GLS:</p>
            <ul>
              <li>Paketlieferungen im Nah- und Fernverkehr – schnell und termingerecht</li>
              <li>Direkte Zustellung von Sendungen für Hermes und GLS an Privat- und Geschäftskunden</li>
              <li>Effiziente Tourenplanung sowie sorgfältige und sichere Handhabung aller Pakete</li>
            </ul>
          </div>
        </article>

        <article className="info-card cta-card reverse">
          <img src={img5} alt="Karriere" />
          <div className="card-content">
            <h2>Verstärke unser Team!</h2>
            <p>Suchst du nach einer neuen beruflichen Perspektive in einem motivierten und freundlichen Arbeitsumfeld?</p>
            <p>Wir freuen uns auf zuverlässige und teamorientierte Fahrer sowie Mitarbeiter (m/w/d).</p>

            <button onClick={navigateToJobs} className="apply-button">
              Jetzt bewerben
            </button>
          </div>
        </article>
      </div>
    </div>
  );
}

export default Content;